<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              :isRequiredFarms="true"
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              classFarms="col-12 col-sm-6 col-md-6 col-lg-4 col-xl"
              classLots="col-12 col-sm-6 col-md-6 col-lg-4 col-xl"
            >
              <template slot="prev">
                <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 pt-3">
                  <label for="">{{ $t('common_words.evaluations') }}: * </label>
                  <br />
                  <el-select
                    clearable
                    collapse-tags
                    style="width: 100%"
                    filterable
                    class="select-primary custom-width-select shadow-sm required-evaluation_id"
                    v-model="evaluation_id"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in evaluations"
                      :key="item.id + item.name"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
    </div>
    <div class="col-12">
      <div v-if="tableData.length > 0">
        <Legend></Legend>
        <card>
          <el-collapse class="custom-el-collapse" v-model="activeFarm">
            <el-collapse-item
              class="custom-collapse-item collapse-data"
              v-for="(farm, index) in tableData"
              :name="tableData[index][0].farm_id.toString()"
              :key="index"
            >
              <template slot="title">
                <span style="text-transform: capitalize">
                  <strong>{{ $t('common_words.farm') }}: </strong>
                  {{ tableData[index][0].farm_name }}
                </span>
              </template>
              <div class="table-responsive center">
                <div v-for="(evaluations, index2) in farm" :key="index2">
                  <table
                    class="table table-striped table-bordered not-last-td table-data mt-3 mb-5"
                  >
                    <thead>
                      <tr class="cusmtom-thead-color">
                        <th
                          colspan="4"
                          scope="col"
                          class="text-center p-3 custom-header-label"
                        >
                          <strong>
                            {{ $t('common_words.farm') }}:
                            {{ evaluations.farm_name }}
                            {{
                              evaluations.lot_name
                                ? $t('common_words.allotment') +
                                  ': ' +
                                  evaluations.lot_name
                                : ''
                            }}</strong
                          >
                        </th>
                      </tr>
                      <tr class="cusmtom-thead-color">
                        <th
                          scope="col"
                          class="text-center p-3 custom-header-label"
                        >
                          <strong>
                            {{ $t('common_words.sub_category') }}</strong
                          >
                        </th>
                        <th
                          scope="col"
                          class="text-center p-3 custom-header-label"
                        >
                          <strong>
                            {{
                              $t('common_words.compliance_percentage')
                            }}</strong
                          >
                        </th>
                        <th
                          scope="col"
                          class="text-center p-3 custom-header-label"
                        >
                          <strong>
                            {{ $t('common_words.observations') }}</strong
                          >
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(subcategory, index3) in evaluations.subcategory"
                        :key="index3"
                      >
                        <td>{{ subcategory.name }}</td>
                        <td
                          :class="`text-center ${getTotalComplianceColor(
                            subcategory.total_compliance
                          )}`"
                        >
                          {{
                            parseFloat(subcategory.total_compliance).toFixed(2)
                          }}%
                        </td>
                        <td>
                          {{ subcategory.all_observations }}
                        </td>
                      </tr>
                      <tr class="cusmtom-thead-color">
                        <td class="text-center" colspan="2">
                          <strong>{{
                            $t('audit.total_compliance_percentage')
                          }}</strong>
                        </td>
                        <td
                          :class="`text-center ${getColorType(
                            evaluations.subcategory
                          )}`"
                        >
                          <strong>
                            {{ getTotalCompliance(evaluations.subcategory) }}%
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import Filter from 'src/components/Filter/Filters.vue';
import i18n from 'src/i18n';
import Legend from 'src/views/Pages/Dashboard/AdvancedAudit/Components/Legend.vue';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [Filter.name]: Filter,
    Legend,
  },
  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },
  data() {
    return {
      valueCollapse: null,
      activeName: 'filter',
      activeFarm: [],
      evaluations: [],
      evaluation_id: null,
      model: {},
    };
  },
  mixins: [MixinMasters, MixinPermissions, MixinMenu, MixinForm],
  methods: {
    handleFilter(data) {
      this.dataFilter = { ...data };
      this.activeFarm = [];
      this.getData();
    },
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    getData() {
      if (!isset(this.evaluation_id)) {
        return this.validationInputsRequired('evaluation_id');
      }
      this.showHideLoading(true);
      let data = this.dataFilter;

      if (data.bySel === 'Año') {
        data.datei += '-01-01';
        data.datef += '-12-31';
      }
      data.evaluation_id = this.evaluation_id;
      data.route = 'advanced/audits/generalreport';
      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data;
          for (let index = 0; index < this.tableData.length; index++) {
            const farmId = this.tableData[index][0].farm_id;
            this.activeFarm.push(farmId.toString());
          }
          if (this.tableData.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          }
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    getTotalCompliance(subcategories) {
      let sumCompliance = 0;
      for (let index = 0; index < subcategories.length; index++) {
        sumCompliance += subcategories[index].total_compliance;
      }
      const totalCompliance = parseFloat(sumCompliance) / subcategories.length;

      return totalCompliance.toFixed(2);
    },
    getColorType(subcategories) {
      const percentage = this.getTotalCompliance(subcategories);

      return this.getColor(percentage);
    },
    getColor(percentage) {
      if (percentage < 86) {
        return 'danger-value';
      } else if (percentage >= 87 && percentage <= 90) {
        return 'warning-value';
      } else if (percentage >= 91 && percentage < 95) {
        return 'success-value';
      } else {
        return 'successfully-value';
      }
    },
    getTotalComplianceColor(totalCompliance) {
      return this.getColor(totalCompliance);
    },
  },
  created() {
    if (this.isIndex()) {
      Axios.getMasters('advanced/audits/inspections').then(
        (responseEvalluations) =>
          (this.evaluations = responseEvalluations.data.data)
      );
    } else {
      this.showHideLoading();
    }
  },
  mounted() {
    this.selectedItemOnMenu('advanced');
  },

  destroyed() {
    this.deselectedItemOnMenu('advanced');
  },
};
</script>
<style scoped>
.danger-value {
  border-bottom: 4px solid #ff0000 !important;
}
.warning-value {
  border-bottom: 4px solid #ffff00 !important;
}
.success-value {
  border-bottom: 4px solid #008000 !important;
}
.successfully-value {
  border-bottom: 4px solid #0000ff !important;
}
</style>
